import { gql } from "@apollo/client";

export const GET_SHOP_DATA_FOR_RECOMMENDATION = gql`
  query GetShopDataForRecommendation {
    getShopDataForRecommendation
  }
`;

export const GET_MY_SHOP_PRIMARY_STRATEGY = gql`
  query GetMyShopPrimaryStrategy($select: [String!]) {
    getMyShopPrimaryStrategy(select: $select) {
      id
      name
      email
      primary_strategy_id
      secondary_strategy_id
      primary_strategy {
        id
        title
        short_description
        description
        problem
        research
        cluster_flag
        recommended_strategy
        assessment_report
        updatedAt
        isCompleted
      }
      secondary_strategy {
        id
        title
        short_description
        description
        problem
        research
        cluster_flag
        recommended_strategy
        assessment_report
        updatedAt
        isCompleted
      }
    }
  }
`;

export const GET_ACTIONS_GROUPED_BY_FOCUS_AREA = gql`
  query GetActionsGroupedByFocusArea($userId: ID) {
    getActionsGroupedByFocusArea(userId: $userId) {
      user_id
      shop_id
      primary_strategy_id
      report_ids
      focusAreas {
        focusArea
        actions {
          id
          user_id
          shop_id
          report_id
          strategy_id
          product_id
          blog_id
          article_id
          cluster_flag
          recommended_strategy
          department
          title
          description
          focusArea
          status
          due_date
          createdAt
          tasks {
            id
            action_id
            product_id
            blog_id
            article_id
            task_title
            short_description
            description
            isCompleted
            isApproved
            status
            focusArea
            department
            assignedTo
            expected_result
            tokens_used
            createdAt
            due_date
            updatedAt
          }
        }
      }
    }
  }
`;

export const GET_PRIMARY_TASK_PROGRESS = gql`
  query GetPrimaryTaskProgress {
    getPrimaryTaskProgress {
      total
      completed
      percent
      allCompleted
      promoted
      strategyCompleted
      cluster_flag
    }
  }
`;

export const GET_AI_GREETING = gql`
  query GetAIGreeting {
    getAIGreeting {
      text
    }
  }
`;

export const GET_SECONDARY_TASK_PROGRESS = gql`
  query GetSecondaryTaskProgress {
    getSecondaryTaskProgress {
      total
      completed
      percent
      allCompleted
      promoted
      cluster_flag
    }
  }
`;

export const GET_USER_ACCOUNT_TOKENS = gql`
  query GetUserAccountTokens {
    getUserAccountTokens {
      googleToken
      googleRefreshToken
      facebookToken
      instagramToken
      instagramUsername
      shopifyToken
      tiktokToken
      tiktokBusinessToken
      hasGoogleConnection
      hasMetaConnection
      hasTikTokConnection
      hasTikTokAdsConnection
      hasShopifyConnection
      hasMetaBusinessPage
      hasMetaAdsManager
      hasMetaPixel
      hasInstagramBusiness
      hasGoogleAnalytics
      hasSearchConsole
      hasMerchantCenter
      updatedAt
    }
  }
`;

export const GET_SHOP_INTEGRATION_STATUS = gql`
  query GetShopIntegrationStatus($shopId: ID, $userId: ID) {
    getShopIntegrationStatus(shopId: $shopId, userId: $userId) {
      shopId
      checkedAt
      shopify {
        connected
        status
        detail
      }
      google {
        connected
        status
        detail
        analyticsConnected
        searchConsoleConnected
        merchantCenterConnected
        accountEmail
        mismatch
      }
      meta {
        connected
        status
        detail
        adsConnected
        instagramConnected
        pixelConnected
        businessConnected
        mismatch
      }
      tiktok {
        connected
        status
        detail
        creatorConnected
        adsConnected
        mismatch
      }
    }
  }
`;

export const GET_CURRENT_REPORTS_BY_USER = gql`
  query GetCurrentReportsByUserId($userId: ID!, $shopId: ID) {
    getCurrentReportsByUserId(userId: $userId, shopId: $shopId) {
      id
      name
      shop_id
      user_id
      createdDate
      createdAt
      updatedAt
      data
    }
  }
`;

export const GET_SUBSCRIPTION_STATUS = gql`
  query GetSubscriptionStatus {
    getSubscriptionStatus {
      type
      status
      premiumTier
      planFamily
      stripeCustomerId
      stripeSubscriptionId
      currentPeriodEnd
      creditTier
      totalCredits
      creditsUsed
      addOns {
        extraSeats
        extraBrands
      }
      reportAccess {
        accessSource
        canUseAllReports
        allowedViews
        defaultViewMode
        defaultHistoricalRange
      }
    }
  }
`;

export const GET_NOTIFICATION_SETTINGS = gql`
  query MyNotificationSettings {
    myNotificationSettings {
      receiveNotification
      receivePushNotification
      receiveEmailNotification
      notificationToken
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query MyNotifications($limit: Int = 50) {
    myNotifications(limit: $limit) {
      items {
        id
        title
        body
        type
        data
        read
        createdAt
        updatedAt
      }
      unreadCount
    }
  }
`;

export const GET_CHAT_SUGGESTIONS = gql`
  query GetChatSuggestions($location: String!, $topic: String!) {
    getChatSuggestions(location: $location, topic: $topic) {
      id
      text
      icon
      theme
      order
    }
  }
`;

export const GET_MY_SHOPS = gql`
  query GetMyShops {
    getMyShops {
      id
      name
      email
      myshopifyDomain
      primaryDomain
      shopOwnerName
      currencyCode
      country
      countryCode
      reportAccess {
        accessSource
        canUseAllReports
        allowedViews
        defaultViewMode
        defaultHistoricalRange
      }
    }
  }
`;
